/**
 * Kontaktformular (Website) – Public API, nur API-Key nötig.
 * Endpoint und API Key aus AWS AppSync Konsole. Optional dedizierte Vars,
 * sonst Fallback auf das Haupt-AppSync:
 *   REACT_APP_CONTACT_GRAPHQL_ENDPOINT
 *   REACT_APP_CONTACT_API_KEY
 */

export const SUBMIT_CONTACT_MESSAGE = `
  mutation SubmitContactMessage($input: SubmitContactMessageInput!) {
    submitContactMessage(input: $input) {
      success
      message
      contactID
    }
  }
`;

/** GraphQL endpoint for the contact form (public API). Fallback to main AppSync if not set. */
export const getContactMessageConfig = () => ({
  endpoint:
    process.env.REACT_APP_CONTACT_GRAPHQL_ENDPOINT ||
    process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
  apiKey:
    process.env.REACT_APP_CONTACT_API_KEY ||
    process.env.REACT_APP_AWS_APPSYNC_API_KEY,
});
